/* A2 Drop · Quick signup (snippets/a2-drop-quick.liquid). Mounts every [data-a2-drop-quick]:
   1. email → Klaviyo client/subscriptions (list from custom.sp_drop) → fire-and-forget
      "SP Drop <n> Signup" event + CRM identify → dataLayer sp_drop<n>_signup {source: placement}
      → localStorage a2_drop<n>_signed = 1 + document event "a2:drop-signed" (the LP sticky bar hides)
      → the optional build step.
   2. build chips + Done (or "Not sure") → "SP Drop <n> Build Picked" event (+ CRM identify with the
      builds) → dataLayer sp_drop<n>_build_pick → thanks line.
   Compact clock [data-a2-drop-clock][data-target]: "5D 03H 12M", 1 s tick, hidden once the target passes.
   Inside the homepage slider ([data-wa-hs]) a focus in the form holds rotation for the rest of the visit.
   Payload builders: assets/a2-drop-signup.js (window.A2Drop). */
(function (w, d) {
  'use strict';
  if (w.A2DropQuick) { return; }
  w.A2DropQuick = true;

  function each(list, fn) { for (var i = 0; i < list.length; i++) { fn(list[i], i); } }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function readCookie(name) {
    var m = d.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function attribution() {
    var out = {}, st = {};
    try { st = JSON.parse(sessionStorage.getItem('a2_attribution')) || {}; } catch (e) {}
    each(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'], function (k) { if (st[k]) { out[k] = String(st[k]); } });
    return out;
  }
  function ga4() { var g = readCookie('_ga'); return g ? g.split('.').slice(-2).join('.') : null; }
  function push(o) { w.dataLayer = w.dataLayer || []; w.dataLayer.push(o); }

  /* ---------- compact clocks ---------- */
  var clocks = [];
  function tick() {
    var now = Date.now();
    each(clocks, function (c) {
      var s = Math.max(0, Math.floor((c.target - now) / 1000));
      if (s === 0) { c.el.hidden = true; return; }
      var t = Math.floor(s / 86400) + 'D ' + pad(Math.floor(s % 86400 / 3600)) + 'H ' + pad(Math.floor(s % 3600 / 60)) + 'M';
      if (c.v.textContent !== t) { c.v.textContent = t; }
    });
  }

  function mount(root) {
    if (root.__a2dq) { return; }
    root.__a2dq = true;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-a2dq-config]').textContent) || {}; } catch (e) { cfg = {}; }
    var placement = root.getAttribute('data-placement') || 'unknown';
    var num = cfg.number || 3;
    var form = root.querySelector('[data-a2dq-form]');
    var emailEl = root.querySelector('input[name=email]');
    var hpEl = root.querySelector('[data-a2dq-hp]');
    var btn = root.querySelector('[data-a2dq-submit]');
    var msg = root.querySelector('[data-a2dq-msg]');
    var fine = root.querySelector('[data-a2dq-fine]');
    var pick = root.querySelector('[data-a2dq-pick]');
    var thanks = root.querySelector('[data-a2dq-thanks]');
    var label = btn ? btn.textContent : '';
    var busy = false, email = '';

    var clockEl = root.querySelector('[data-a2-drop-clock][data-target]');
    if (clockEl) {
      var t = Date.parse(clockEl.getAttribute('data-target'));
      if (isNaN(t) || t <= Date.now()) { clockEl.hidden = true; }
      else { clocks.push({ el: clockEl, v: clockEl.querySelector('[data-a2-drop-clock-v]') || clockEl, target: t }); }
    }

    var slider = root.closest ? root.closest('[data-wa-hs]') : null;
    if (slider) {
      root.addEventListener('focusin', function () { if (slider.waHs && slider.waHs.hold) { slider.waHs.hold(true); } });
    }

    function err(text) { msg.className = 'a2dq-msg err'; msg.textContent = text; }
    function kPost(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      });
    }
    function crm(body) {
      if (!cfg.crm || !body) { return; }
      try { fetch(cfg.crm, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () {}); } catch (x) {}
    }
    function signed() {
      try { localStorage.setItem('a2_drop' + num + '_signed', '1'); } catch (e) {}
      try { d.dispatchEvent(new CustomEvent('a2:drop-signed', { detail: { placement: placement } })); } catch (e) {}
    }
    function showPick() {
      form.hidden = true; if (fine) { fine.hidden = true; }
      msg.className = 'a2dq-msg'; msg.textContent = '';
      pick.hidden = false;
      try { pick.focus({ preventScroll: true }); } catch (e) {}
    }
    function finish() {
      pick.hidden = true; thanks.hidden = false;
      try { thanks.focus({ preventScroll: true }); } catch (e) {}
    }
    function common() {
      return { email: email, pageUrl: location.href, utm: attribution(), shopifyClientId: readCookie('_shopify_y'),
        ga4ClientId: ga4(), drop: cfg.drop, dropNumber: num, placement: placement };
    }

    emailEl.addEventListener('input', function () { emailEl.removeAttribute('aria-invalid'); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) { return; }
      msg.className = 'a2dq-msg'; msg.textContent = '';
      var em = (emailEl.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { emailEl.setAttribute('aria-invalid', 'true'); err('Enter a valid email address.'); emailEl.focus(); return; }
      email = em;
      /* Honeypot: bots see success, nothing is sent. */
      if (hpEl && hpEl.value) { showPick(); return; }
      var D = w.A2Drop;
      if (!D || !D.buildPayloadsQuick || !cfg.list) { err("That didn't go through. Please try again in a moment."); return; }
      var o = common(); o.list = cfg.list; o.source = cfg.source;
      var pl = D.buildPayloadsQuick(o);
      busy = true;
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-busy') || label; }
      kPost('subscriptions', pl.subscription)
        .then(function (r) { if (!r.ok) { throw r; } })
        .then(function () {
          try { kPost('events', pl.event).catch(function () {}); } catch (x) {}
          crm(pl.crm);
          push({ event: 'sp_drop' + num + '_signup', source: placement, builds: [], build: '', size: 'Not sure', sms_opt_in: false });
          signed();
          showPick();
        })
        .catch(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.textContent = label; }
          err("That didn't go through. Please try again in a moment.");
        });
    });

    var chips = root.querySelectorAll('.a2dq-chip');
    var notSure = root.querySelector('[data-not-sure]');
    each(chips, function (c) {
      c.addEventListener('click', function () {
        if (c === notSure) { sendPick(true); return; }
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });
    var sent = false;
    function sendPick(isNotSure) {
      if (sent) { return; }
      var builds = [];
      if (!isNotSure) {
        each(chips, function (c) {
          if (c === notSure || c.getAttribute('aria-pressed') !== 'true') { return; }
          var cols = [];
          try { cols = JSON.parse(c.getAttribute('data-colors') || '[]') || []; } catch (e) {}
          builds.push({ handle: c.getAttribute('data-handle'), name: c.getAttribute('data-name'), colors: cols });
        });
        if (!builds.length) { finish(); return; }
      }
      sent = true;
      var D = w.A2Drop;
      if (email && D && D.buildPickPayloads && !(hpEl && hpEl.value)) {
        var o = common(); o.builds = builds; o.notSure = !!isNotSure;
        var pl = D.buildPickPayloads(o);
        try { kPost('events', pl.event).catch(function () {}); } catch (x) {}
        crm(pl.crm);
        var names = []; each(builds, function (b) { names.push(b.name); });
        push({ event: 'sp_drop' + num + '_build_pick', source: placement, builds: names, not_sure: !!isNotSure });
      }
      finish();
    }
    var done = root.querySelector('[data-a2dq-done]');
    if (done) { done.addEventListener('click', function () { sendPick(false); }); }
  }

  function init() {
    each(d.querySelectorAll('[data-a2-drop-quick]'), mount);
    if (clocks.length) { tick(); w.setInterval(tick, 1000); }
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})(window, document);
